import React, { useState } from "react";
import styled from "styled-components";
//@ts-ignore
import { StoreIcon } from "../../../assets/icons/StoreIcon.jsx";
import { BlackCoinsWallet } from "../../atoms/BlackCoinsWallet";
import { ReferralStoreItem } from "../../molecules/ReferralStoreItem";
import { Confirmation } from "./Confirmation";
//@ts-ignore
import {useTrack} from '../../../services/hooks/useTrack'

interface IStoreItem {
  blackcoins: number;
  note: string;
  description: string;
  imageUrl: string;
  name: string;
  type: string;
  _id: string;
  value: string;
  brand: string;
  deliveryTime: string;
}

interface IProps {
  balance: number;
  purchaseCompleted: (
    id: string,
    data: {
      Produto: string;
      "Valor Giftcard": string;
      "Preço em blackcoins": number | string;
    }
  ) => void;
  items: IStoreItem[];
}

const Container = styled.div`
  background-color: #2c2c2c;
  border-radius: 20px;
  padding: 20px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
  height: 100%;
  box-sizing: border-box;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Title = styled.h3`
  color: white;
  font-size: 20px;
`;

const ItemSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #1e1e1e;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #1e1e1e;
  }
  max-height: 100%;
  padding-right: 10px;
  box-sizing: content-box;
`;

export const ReferralStore = (props: IProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {trackEvent} = useTrack();
  const [modalContent, setModalContent] = useState<{
    price: number;
    title: string;
    icon: string;
    id: string;
    monetaryValue: string;
    text: {
      textTitle: string;
      textValue: string;
      textNote: string;
    };
  } | null>(null);

  function giftCardValueAndNameSorter(value: string, type: string, brand: string) {
    let temp;
    if (type === 'giftcard') {
      if (brand === 'Blackbook') {
        if (value === '30,00') {
          temp = 'Mensal'
        } else if (value === '180,00') {
          temp = 'Semestral'
        } else {
          temp = 'Anual'
        }
      } else {
        temp = Number(value.split(',')[0])
      }
    } else {
      temp = ''
    }
    return temp;
  }

  return (
    <Container>
      {isModalOpen && modalContent && (
        <Confirmation
          purchaseCompleted={(
            id: string,
            data: {
              Produto: string;
              "Valor Giftcard": string;
              "Preço em blackcoins": number | string;
            }
          ) => {
            props.purchaseCompleted(id, data);
            setIsModalOpen(false);
          }}
          isOpen={isModalOpen}
          setIsOpen={() => setIsModalOpen(false)}
          ConfirmationInfo={modalContent}
        />
      )}
      <TitleSection>
        <TitleContainer>
          <StoreIcon />
          <Title>Loja Blackbook</Title>
        </TitleContainer>
        <BlackCoinsWallet CoinsAmmount={props.balance} />
      </TitleSection>
      <ItemSection>
        {props.items &&
          props?.items?.map((item) => (
            <ReferralStoreItem
              onClick={() => {
                trackEvent("Indique - Clicou em Comprar Giftcard", {
                  Produto: item.description,
                  "Preço em Blackcoins": item.blackcoins,
                });
                setIsModalOpen(true);
                setModalContent({
                  price: item.blackcoins,
                  title: `Comprar ${
                    item.type === "giftcard" ? "Gift Card" : "Livro"
                  }`,
                  icon: item.imageUrl
                    ? item.imageUrl
                    : require("../../../assets/images/fallbackStoreImage.png"),
                  id: item._id,
                  monetaryValue: item.value,
                  text: {
                    textTitle: item.name,
                    textValue: item.description,
                    textNote:
                      "Envio " +
                      (item.type === "giftcard" ? "por email em " : "em ") +
                      item.deliveryTime +
                      ".",
                  },
                });
              }}
              icon={
                item.imageUrl
                  ? item.imageUrl
                  : require("../../../assets/images/fallbackStoreImage.png")
              }
              title={item.brand}
              price={item.blackcoins}
              type={item.type === "giftcard" ? "Gift Card" : "Livro"}
              value={giftCardValueAndNameSorter(item.value, item.type, item.brand)}
              purchaseable={item.blackcoins <= props.balance ? true : false}
            />
          ))}
      </ItemSection>
    </Container>
  );
};
